module.exports = __webpack_public_path__ + "f81231ec6eb5c77f6d2d0e57a541a8af.jpg";